// import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "../../common/Button";
import * as XLSX from "xlsx";
import { Stack } from "@mui/system";
import { FormLabel, Grid, Typography } from "@mui/material";
import Laptop from "../../../Images/Icon awesome-laptop (2).svg";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import "./BrowseStudent.scss";
import { studentDetails } from "../../../redux/features/CreateSessionReducer";
import { useDispatch, useSelector } from "react-redux";
import { CreateTraining } from "../../../redux/features/CreateSession";
import Closed from "../../../Images/closeImage.png";
import Upload from "../../../Images/Icon_Upload.svg";
import moment from "moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import api_call from "../../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import { toast } from "react-toastify";
import { API } from "../../../globals/constants";
import {
  scheduleTraining,
  sessionDetails,
  systemSpecification,
  cloudType,
} from "../../../redux/features/CreateSessionReducer";
import MultiLine_Spinner from "../../multiline_spinner/Multiline_spinner";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CsvDownloader from "react-csv-downloader";
import _ from "lodash";

function BrowseStudent(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedValue, setSelectedValues] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadData, setUploadData] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const students_samples_files_JSON = [
    {
      name: "John Doe",
      email_id: "abc@gmaildummy.com",
      is_machine_required: "yes",
    },
  ];
  const handleButtonClick = () => {
    document.getElementById("file-upload").click();
  };
  const selectedSessionOption = useSelector((state) => {
    console.log(
      "check thr type of cloudp]p]p browse student",
      state?.CreateSession?.cloudType
    );
    return state?.CreateSession?.cloudType;
  });
  const convertToJson = (csv) => {
    var lines = csv.split("\n");

    var result = [];

    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length - 1; i++) {
      var obj = {};
      var currentline = lines[i].split(",");
      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j]?.trim();
      }
      const arr1 = uploadData.filter((d) => d.email_id === obj.email_id);
      if (obj.email_id === "" || arr1.length > 0) {
      } else {
        obj.is_machine_required === "yes" ||
        obj.is_machine_required === "Yes" ||
        obj.is_machine_required === "YES"
          ? (obj.is_machine_required = true)
          : (obj.is_machine_required = false);
        let temp = obj.email_id;
        obj.email_id = temp?.trim();
        result.push(obj);
      }
    }

    const key = "email_id";
    //return result; //JavaScript object
    const arrayUniqueByKey = [
      ...new Map(result.map((item) => [item[key], item])).values(),
    ];
    return JSON.parse(JSON.stringify(arrayUniqueByKey)); //JSON
  };

  const validateFile = (csv) => {
    var lines = csv.split("\n");
    let validation = true;

    var result = ["name", "email_id", "is_machine_required"];

    var headers = lines[0].split(",");
    if (headers.length === result.length) {
      for (var j = 0; j < result.length; j++) {
        if (headers.includes(result[j])) {
          validation = true;
        } else {
          setErrorMessage({
            errorMessage: `${result[j]} field is missing`,
          });
          validation = false;
          break;
        }
      }
    } else {
      toast.error(
        `Invalid file format, Please download sample file and upload student's data`,
        {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: "invalidfields",
          style: { background: "#000", color: "#ffffff" },
        }
      );
      validation = false;
    }
    console.log("check the headers and lines", lines, headers);

    return validation; //JSON
  };
  const validateColumFile = (csv) => {
    var lines = csv.split("\n");
    let validation = true;
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const contact_regex = /^[0-9]*(?:\.\d{1,2})?$/;
    const script_regex =
      /^(?=[a-zA-ZÀ-žäöüÄÖÜß0-9~@#$&^*/;`%()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"])/;
    const location_regex =
      /^(?=[a-zA-Z~@#$&^*/;`%()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"])/;

    var headers = lines[0].split(",");
    if (lines.length >= 2) {
      for (var i = 1; i < lines.length - 1; i++) {
        var obj = {};
        var currentline = lines[i].split(",");
        for (var k = 0; k < headers.length; k++) {
          obj[headers[k]] = currentline[k];
        }
        if (obj.email_id === "") {
          validation = false;
          setErrorMessage({
            errorMessage: `email field data incorrect or empty`,
          });
          toast.error(`email field data incorrect or empty`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            toastId: "invalidfields",
            style: { background: "#000", color: "#ffffff" },
          });
          break;
        } else if (obj.is_machine_required === "") {
          validation = false;
          setErrorMessage({
            errorMessage: `is_machine_required field data incorrect or empty`,
          });
          toast.error(`is_machine_required field data incorrect or empty`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            toastId: "invalidfields",
            style: { background: "#000", color: "#ffffff" },
          });
          break;
        } else if (!re.test(obj.email_id.trim())) {
          validation = false;
          setErrorMessage({
            errorMessage: `email field data incorrect `,
          });
          toast.error(`email field data incorrect`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            toastId: "invalidfields",
            style: { background: "#000", color: "#ffffff" },
          });
          break;
        } else if (!script_regex.test(obj.name.trim())) {
          validation = false;
          setErrorMessage({
            errorMessage: `Name field data incorrect `,
          });
          toast.error(`Name field data incorrect`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            toastId: "invalidfields",
            style: { background: "#000", color: "#ffffff" },
          });
          break;
        } else if (
          obj.is_machine_required.trim() !== "yes" &&
          obj.is_machine_required.trim() !== "no" &&
          obj.is_machine_required.trim() !== "Yes" &&
          obj.is_machine_required.trim() !== "No" &&
          obj.is_machine_required.trim() !== "YES" &&
          obj.is_machine_required.trim() !== "NO"
        ) {
          validation = false;
          setErrorMessage({
            errorMessage: `is machine required field data incorrect `,
          });
          toast.error(`is machine required field data incorrect`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            toastId: "invalidfields",
            style: { background: "#000", color: "#ffffff" },
          });
          break;
        } else {
          validation = true;
        }
      }
    } else {
      validation = false;
      setErrorMessage({
        errorMessage: `Blank File with No Records`,
      });
      toast.error(`Blank File with No Records`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: "invalidfields",
        style: { background: "#000", color: "#ffffff" },
      });
      return validation;
    }
    //return result; //JavaScript object
    return validation; //JSON
  };
  const add3Dots = (string, limit) => {
    let dots = "...";
    if (string) {
      if (string.length > limit) {
        string = string.substring(0, limit) + dots;
      }
      return string;
    }
  };
  const theme = createTheme({
    components: {
      MuiSwitch: {
        styleOverrides: {
          switchBase: {
            // Controls default (unchecked) color for the thumb
            color: "#338FEE",
          },

          colorPrimary: {
            "&.Mui-checked": {
              // Controls checked color for the thumb
              color: "#e0e0e0",
            },
          },
          track: {
            // Controls default (unchecked) color for the track
            opacity: 0.2,
            backgroundColor: "#338FEE",
            ".Mui-checked.Mui-checked + &": {
              // Controls checked color for the track
              opacity: 0.7,
              backgroundColor: "#e0e0e0",
            },
          },
        },
      },
    },
  });
  const { CreateSession } = useSelector((state) => {
    console.log("state data", state);
    return state;
  });
  const training = useSelector((state) => {
    console.log("state data", state);
    return state?.createTraining;
  });

  const cookies = new Cookies();
  const loginData = cookies.get("loginData");
  const getTrainingData = () => {
    if (training?.loading === true) {
    } else {
      if (training?.CreateTraining?.status === 200) {
        navigate("/training");
      }
    }
  };
  const {
    title,
    tags,
    host,
    feedback_template_id,
    description,
    is_private,
    email_template_id,
  } = CreateSession?.sessionDetails;
  const {
    instance_id,
    machine_ami_id,
    region_code,
    zone,
    instructor_id,
    studio_id,
  } = CreateSession?.systemSpecification;
  const { session_start_date, session_end_date, training_date, days } =
    CreateSession?.scheduleTraining;
  const onConfirm = async () => {
    setIsloading(true);
    if (
      selectedSessionOption?.sessionType === "longtermsession" &&
      uploadData.length === 0
    ) {
      setIsloading(false);
      toast.error(`Please add student to the longterm session`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else {
      let bodyParam = {};
      if (uploadData) {
        dispatch(
          studentDetails({
            student: [...uploadData],
          })
        );
      }
      let convertData = (training_date) => {
        console.log("hello Training_date", training_date);
        if (training_date) {
          let newSortedTrainingDate = _.orderBy(
            training_date,
            ["session_start_date"],
            ["asc"]
          );
          console.log(newSortedTrainingDate);
          return newSortedTrainingDate.map((item) => {
            let temp = {
              session_start_date: item.session_start_date,
              session_end_date: item.session_end_date,
              day: item.day,
              sessions_week: item.sessions_week,
            };
            return temp;
          });
        } else {
          return "";
        }
      };
      let data = convertData(training_date);
      console.log("traininng date checj----99999", training_date);
      bodyParam = {
        title: title,
        tags: tags,
        host: host,
        feedback_template_id: feedback_template_id,
        description: description,
        is_private: is_private,
        instructor_id:
          loginData.role_code === "INSTRUCTOR" ? loginData.id : instructor_id,
        studio_id:
          loginData.role_code === "STUDIO_ADMIN" ||
          loginData.role_code === "INSTRUCTOR"
            ? loginData.studio_id
            : studio_id,
        instance_id: instance_id,
        machine_ami_id: machine_ami_id,
        region_code: region_code,
        days: JSON.stringify(days),
        zone: zone,
        email_template_id: email_template_id,
        created_by: loginData.id,
        is_all_day: false,
        is_active: true,
        student: [...uploadData],
        is_free: true,
        is_paid: false,
        cost: "",
        currency: "",
        session_repeat: "",
      };
      if (selectedSessionOption?.sessionType === "longtermsession") {
        if (selectedSessionOption?.gcpType === "Schedule") {
          bodyParam.cloud_type = "GCP";
          bodyParam.immediate_launch = false;
          bodyParam.training_date = [
            {
              session_start_date: moment(
                new Date(training_date[0].session_start_date)
              ).format(
                `YYYY-MM-DD ${moment(
                  training_date[0].session_start_date
                ).format("HH:mm:ss")}`
              ),
              session_end_date: moment(
                training_date[0].session_end_date
              ).format(
                `YYYY-MM-DD ${moment(training_date[0].session_end_date).format(
                  "HH:mm:ss"
                )}`
              ),
              day: moment(training_date[0].session_start_date).format("ddd"),
              sessions_week: `w0`,
            },
          ];
          bodyParam.session_end_date = moment(
            training_date[0].session_end_date
          ).format("YYYY-MM-DD HH:mm:ss");
          bodyParam.session_start_date = moment(
            training_date[0].session_start_date
          ).format("YYYY-MM-DD HH:mm:ss");
        } else {
          console.log(
            "check the end date moment-----",
            moment(training_date[0].session_end_date).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            training_date[0].session_end_date
          );
          bodyParam.cloud_type = "GCP";
          bodyParam.immediate_launch = true;
          bodyParam.training_date = [
            {
              session_start_date: moment().format("YYYY-MM-DD HH:mm:ss"),
              session_end_date: moment(
                training_date[0].session_end_date
              ).format("YYYY-MM-DD HH:mm:ss"),
              day: moment(training_date[0].session_start_date).format("ddd"),
              sessions_week: `w0`,
            },
          ];
          bodyParam.session_end_date = moment(
            training_date[0].session_end_date
          ).format("YYYY-MM-DD HH:mm:ss");
          bodyParam.session_start_date = moment().format("YYYY-MM-DD HH:mm:ss");
        }
      } else {
        bodyParam.cloud_type = "AWS";
        bodyParam.immediate_launch = false;
        bodyParam.training_date = [...data];
        bodyParam.session_end_date = moment(session_end_date).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        bodyParam.session_start_date = moment(session_start_date).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      console.log("check body param======", bodyParam, days);
      const response =
        loginData.role_code === "STUDIO_ADMIN"
          ? await api_call(
              "post",
              `${
                CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
                API.END_POINTS.TRAINING_STUDIO_ADMIN
              }`,
              {},
              {},
              bodyParam
            )
          : loginData.role_code === "INSTRUCTOR"
          ? await api_call(
              "post",
              `${
                CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
                API.END_POINTS.TRAINING_INSTRUCTOR
              }`,
              {},
              {},
              bodyParam
            )
          : await api_call(
              "post",
              `${
                CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
                API.END_POINTS.GET_TRAINING_LISTING
              }`,
              {},
              {},
              bodyParam
            );

      if (response.status === 200) {
        navigate("/training");
        dispatch(scheduleTraining({}));
        dispatch(systemSpecification({}));
        dispatch(sessionDetails({}));
        dispatch(cloudType({}));
        setIsloading(false);
        toast.success(`Training created successfully`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      } else {
        setIsloading(false);
        if (response.status === 409) {
          toast.error(`Session with same name exist`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (response.status === 400) {
          toast.error(`${response?.err?.data?.msg1}`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          navigate("/training");
        }
      }
    }
  };
  const handleCheck = (index) => {
    let data = [...uploadData];
    let data2 = data.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          is_machine_required: !item.is_machine_required,
        };
      } else {
        return item;
      }
    });
    setUploadData([...data2]);
  };
  const handleCross = (index) => {
    let data = [...uploadData];
    data.splice(index, 1);
    setUploadData([...data]);
  };
  const onBack = () => {
    dispatch(
      studentDetails({
        student: [...uploadData],
      })
    );
    return props.handleBack();
  };
  const onFileChange = async (e) => {
    setSelectedValues(e.target.files[0]);
    var f = e.target.files[0];
    var file = e.target.files[0];
    var filename = file?.name;
    var regex = new RegExp("(.*?).(csv)$");
    if (regex.test(filename)) {
      const reader = new FileReader();
      reader.onload = async (evt) => {
        // evt = on_file_select event
        /* Parse data */
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
        // this.convertToJson(data)
        console.log(
          "render_data---",
          data,
          validateFile(data),
          validateColumFile(data)
        );
        if (validateFile(data) && validateColumFile(data)) {
          let uploadDataTemp = [...convertToJson(data)];
          await setUploadData([...uploadData, ...uploadDataTemp]);
        } else {
          console.log("errorMessage.errorMessage", errorMessage);
        }
      };
      reader.readAsBinaryString(f);
    } else {
    }
    e.target.value = null;
  };
  useEffect(() => {
    console.log("training_date ", days);
    if (CreateSession?.studentDetails) {
      setUploadData(
        CreateSession?.studentDetails?.student
          ? [...CreateSession?.studentDetails?.student]
          : []
      );
    }
  }, []);
  // useEffect(() =>{
  //   getTrainingData()
  // },[training?.CreateTraining])

  return (
    <>
      <Grid>
        <Typography variant="h6" className="sample_heading">
          First download the sample file and then upload the file to continue
        </Typography>
      </Grid>
      <Stack direction="row">
        {console.log("error message---", errorMessage)}
        <Grid container className="browse_container">
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={8}
            xl={8}
            className="browse_area"
            onClick={() => handleButtonClick()}
            onChange={(e) => onFileChange(e)}
          >
            <img
              src={Upload}
              className="upload_img"
              // onClick={() => handleButtonClick()}
              // onChange={(e) => onFileChange(e)}
            ></img>
            <input
              id="file-upload"
              onChange={(e) => onFileChange(e)}
              accept=".csv"
              type="file"
              name="fileUpload"
              style={{ display: "none" }}
            />
            <div
              for="file-upload"
              onChange={(e) => onFileChange(e)}
              className=""
            >
              <Typography
                variant="h6"
                id="file-drag"
                className="browse_heading"
                // onClick={() => handleButtonClick()}
                // onChange={(e) => onFileChange(e)}
              >
                Browse
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <CsvDownloader
              //   // id="link"
              //   // href="https://unreal-engine-ui.s3.ap-south-1.amazonaws.com/students_samples_files.csv"
              //   // download
              // >

              id="export_csv"
              filename="student_sample_files.csv"
              separator=","
              columns={[
                { displayName: "name", id: "name" },
                {
                  displayName: "email_id",
                  id: "email_id",
                },
                {
                  displayName: "is_machine_required",
                  id: "is_machine_required",
                },
              ]}
              wrapColumnChar=""
              datas={students_samples_files_JSON}
            >
              <Button
                id="file-drag"
                role="default"
                value="Download Sample file"
                className="sample_file_margin"
              />
            </CsvDownloader>
          </Grid>
        </Grid>
      </Stack>
      <Stack className="browse_content">
        {uploadData.map((value, index) => {
          return (
            <Stack direction="row" className="browseFile">
              <Grid xs={3} sm={3} md={3} lg={3} xl={3}>
                <Stack direction="row" className="browseContent setBorder">
                  <Stack className="MarginImg">
                    <img src={Laptop}></img>
                  </Stack>
                  <Stack className="Content">{add3Dots(value.name, 10)}</Stack>
                </Stack>
              </Grid>
              <Grid
                xs={3}
                sm={3}
                md={3}
                lg={3}
                xl={3}
                className="browseContent setBorder"
              >
                <Stack className="Content">
                  {add3Dots(value.email_id, 16)}
                </Stack>
              </Grid>
              <Grid xs={5} sm={5} md={5} lg={5} xl={5}>
                <Stack direction="row" className="browseContent ">
                  <Stack>
                    <Typography className="Content">
                      Machine Required:
                    </Typography>
                  </Stack>
                  <Stack direction="row" className="MachineReq">
                    <Stack className="Content">Yes</Stack>
                    <Stack>
                      <ThemeProvider theme={theme}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                color="primary"
                                checked={
                                  value.is_machine_required === true
                                    ? false
                                    : true
                                }
                                onChange={() => handleCheck(index)}
                              />
                            }
                          />
                        </FormGroup>
                      </ThemeProvider>
                    </Stack>
                    <Stack className="Content">No</Stack>
                  </Stack>
                </Stack>
              </Grid>
              <Grid xs={1} sm={1} md={1} lg={1} xl={1}>
                {/* <Typography
                  className="approval"
                  onClick={() => handleCross(index)}
                >
                  x 
                </Typography> */}
                <img
                  src={Closed}
                  onClick={() => handleCross(index)}
                  alt=""
                  className="approval"
                />
              </Grid>
            </Stack>
          );
        })}
      </Stack>
      {selectedSessionOption?.sessionType === "longtermsession" ? (
        <p style={{ color: "#ff0f0f" }}>
          ⚠️ We kindly request your attention to the fact that once long-term
          training is created, adding more students won't be possible. Please
          review student lists thoughtfully before proceeding. Thank you for
          your understanding.
        </p>
      ) : (
        <></>
      )}
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        {/* add btn_browse class after update is fixed */}
        <div
          className={`flexClass ${
            selectedSessionOption?.sessionType !== "longtermsession"
              ? "awsSessionBtn"
              : "gcpSessionBtn"
          }`}
        >
          <Button value="Back" onClick={() => onBack()} role="default" />
          <Button value="Confirm" onClick={() => onConfirm()} role="primary" />
        </div>
      </Grid>
      {isLoading && <MultiLine_Spinner />}
    </>
  );
}

export default BrowseStudent;
